import axios from "axios";

import { API_BASE_URL } from "configs/AppConfig";
import { signOutSuccess } from "store/slices/authSlice";
import store from "../store";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { notification } from "antd";

const unauthorizedCode = [401, 403];

const service = axios.create({
	baseURL: API_BASE_URL,
	timeout: 60000,
	json: true,
	headers: {
		"Content-Type": "application/json",
	},
	withCredentials: true,
	withXSRFToken: true,
});

// API Request interceptor
service.interceptors.request.use(
	(config) => {
		const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

		if (jwtToken) {
			config.headers = {
				...(config.headers ?? {}),
				Authorization: `Bearer ${jwtToken}`,
			};
		}

		return config;
	},
	(error) => {
		// Do something with request error here
		notification.error({
			message: "Une erreur est survenue",
		});
		Promise.reject(error);
	},
);

// API respone interceptor
service.interceptors.response.use(
	(response) => {
		return response.data;
	},
	(error) => {
		let notificationParam = {
			message: "Une erreur est survenue :",
			description: error?.response?.data?.message,
		};

		// Remove token and redirect
		if (unauthorizedCode.includes(error.response?.status)) {
			notificationParam.message = "Erreur d'authentification.";
			notificationParam.description = "Merci de vous reconnecter.";
			localStorage.removeItem(AUTH_TOKEN);

			store.dispatch(signOutSuccess());
		}

		if (error.response?.status === 404) {
			notificationParam.message = "Non trouvé";
		}

		if (error.response?.status === 500) {
			notificationParam.message = "Erreur serveur interne";
		}

		if (error.response?.status === 508) {
			notificationParam.message = "Temps d'attente dépassé";
		}

		notification.error(notificationParam);

		return Promise.reject(error);
	},
);

export default service;
